var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 12.5H0V27.5H40V12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V12.5H40V0Z",
    fill: "#FF9933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27.5H0V40H40V27.5Z",
    fill: "#128807"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.625C23.1066 25.625 25.625 23.1066 25.625 20C25.625 16.8934 23.1066 14.375 20 14.375C16.8934 14.375 14.375 16.8934 14.375 20C14.375 23.1066 16.8934 25.625 20 25.625Z",
    stroke: "#223049",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21Z",
    stroke: "#223049",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInr);
export default __webpack_public_path__ + "static/media/inr.86f83eebefbcb59ae81005e52f1bc560.svg";
export { ForwardRef as ReactComponent };